import { Badge, Button, Card, Divider, Input, Select, Table } from '@scuf/common';
import { deliveryTimeOptions, listAproved, reasonRejection } from 'models/spareParts';
import { OrderDTO, OrderItemsDTO, OrderHistoryDTO } from 'models/spareParts/orderById';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { orderAtom } from 'resources/atoms/spareParts';
import Budget from './budget';
import { processOrder } from 'resources/api/spareParts_api/processOrder';
import { SPARE_PARTS, notificationAtom } from 'resources';
import useUser from 'helpers/hooks/useUser';
import { UserRole } from 'models/user/sso';
import { RoleComponent } from 'components/roleComponent';
import useFetch from 'helpers/hooks/useFetch';
import Customer from '../../customer';
import { text } from 'stream/consumers';
import { getHistory } from 'resources/api/spareParts_api/getHistory';
import { typeOpt } from 'models/spareParts';
import { formatDate } from 'helpers';

const Price: React.FC = () => {
    const [orderHistory, setOrderHistory] = useState<OrderHistoryDTO[]>([]);
    const [filteredHistory, setShowHistory] = useState<OrderHistoryDTO[]>([]);
    const [orderData, setorderData] = useRecoilState<OrderDTO>(orderAtom);
    const [orderItems, setOrderItems] = useState<OrderItemsDTO[]>();
    const { t } = useTranslation(['spareparts', 'common']);
    const [loading, setLoading] = useState<boolean>(false);
    const [disable, setDisable] = useState<boolean>(false);
    const [typeAprovReject, setTypeAproceReject] = useState<any>();
    const setNotification = useSetRecoilState(notificationAtom);
    const [rejectedItems, setRejectedItems] = useState<number[]>([]);
    const [customerApprovals, setCustomerApprovals] = useState<Record<number, boolean | null>>({});
    const [customReason, setCustomReason] = useState<Record<number, boolean>>({});
    const [itemSeriaisHist, setItemSeriaisHist] = useState<string[]>([]);

    useEffect(() => {
        if (!orderItems && orderData?.orderItems) {
            setOrderItems(orderData?.orderItems ?? []);
        }
    }, [orderData]);

    useEffect(() => {
        let l: string[] = [];
        for (let i of orderData.orderItems) {
            l.push(i.serialNumberEquipment);
        }
        setItemSeriaisHist(l);
    }, [orderData.orderItems]);

    useEffect(() => {
        if (itemSeriaisHist.length === 0) {
            showHistory();
            return;
        }
        history(itemSeriaisHist[0]);
    }, [itemSeriaisHist]);

    useEffect(() => {
        if (orderHistory.length === 0) return;

        let l: string[] = [];
        for (let i of itemSeriaisHist) l.push(i);

        l.shift();
        setItemSeriaisHist(l);
    }, [orderHistory]);

    const { user } = useUser();

    const [, editOrder, loadingEdit] = useFetch<OrderDTO>({
        url: SPARE_PARTS.editOrder,
        method: 'POST',
        onError: 'Change',
        onSuccess: 'Change'
    });

    const process = async () => {
        setLoading(true);
        setDisable(true);
        const aux = { ...orderData, orderItems: [...orderItems!], roleId: parseInt(user?.role!) };

        const resp = await processOrder(aux);
        if (resp.error) {
            setNotification(old => ({ ...old, message: 'Erro ao Processar Pedido' }));
        } else {
            setorderData(resp.data);
            setOrderHistory([]);
            setNotification(old => ({ ...old, message: 'Pedido Processado', type: 'success' }));
        }
        setLoading(false);
    };

    const SUPERADMIN = '1';
    const ADMIN = '2';
    const admin = user?.role === SUPERADMIN || user?.role === ADMIN;

    const warranty = () => {
        let type = typeOpt.find(e => e.value === orderData?.typeId);
        if (type?.value === 4) return true;
        return false;
    };

    const history = async (serial: string) => {
        if (serial === undefined || serial === null || serial === '') return;

        let resp = await getHistory(serial);

        if (resp.status !== 200) return;

        let history: OrderHistoryDTO[] = resp.data as OrderHistoryDTO[];
        let listHistory: OrderHistoryDTO[] = [];

        for (let h of orderHistory) listHistory.push(h);

        for (let h of history) {
            if (orderData.createdAt > h.orderDate) {
                listHistory.push(h);
            }
        }

        setOrderHistory(listHistory);
    };

    const showHistory = () => {
        let filteredHistory: OrderHistoryDTO[] = [];
        let localHistory: OrderHistoryDTO[] = orderHistory;
        for (let h of localHistory) {
            if (orderData.id != h.orderId) {
                filteredHistory.push(h);
            }
        }
        setShowHistory(filteredHistory);
    };

    const isVerifyClientCondition1 = () => {
        return orderItems?.every(
            item =>
                item.adminApproval !== undefined &&
                (item.adminApproval === true || item.adminApproval === false) &&
                item.customerApproval === null
        );
    };

    const isVerifyClientCondition2 = () => {
        return orderItems?.every(item => {
            const customerApproved = item.customerApproval;
            const reasonRejected = item.reasonRejection;
            const isValid =
                customerApproved !== undefined &&
                ((customerApproved === false &&
                    reasonRejected &&
                    reasonRejected.trim() !== '' &&
                    reasonRejected.trim() !== 'Outros motivos') ||
                    customerApproved === true);

            return isValid;
        });
    };

    const isVerifyClientCondition3 = () => {
        const result = orderItems?.every(
            item => item.customerApproval === true && (item.adminApproval === true || item.adminApproval === false)
        );
        return result;
    };

    const isButtonEnabled = () => {
        if (orderData?.typeId === 2) {
            if (orderData?.statusId === 2) {
                return isVerifyClientCondition1();
            } else if (orderData?.statusId === 3) {
                return isVerifyClientCondition2();
            }
        } else if (orderData?.typeId === 3 || orderData?.typeId === 4) {
            return isVerifyClientCondition3();
        }

        return false;
    };

    const showResultBadge = (orderItems?: OrderItemsDTO[], itemId?: number) => {
        let label = '';
        let color: any = 'yellow';
        const admin = orderItems?.find(e => e.id === itemId && e.adminApproval !== undefined)?.adminApproval ?? null;
        const customer = orderItems?.find(e => e.id === itemId && e.customerApproval !== undefined)?.customerApproval ?? null;

        if (customer === null && admin === null) {
            label = 'common:status.Processing';
        } else if (customer === true && admin === null) {
            label = 'common:status.ApprovedByCustomer';
            color = 'green';
        } else if (customer === false && (admin || admin === null)) {
            label = 'common:status.RejectedByCustomer';
            color = 'red';
        } else if ((customer || customer === null) && admin === false) {
            label = 'common:status.RejectedByCompany';
            color = 'red';
        } else if ((customer && admin) || (admin && (orderData.typeId == 3 || orderData.typeId == 4))) {
            label = 'common:status.Approved';
            color = 'green';
        } else if (customer === false && admin === false) {
            label = 'common:status.Rejected';
            color = 'red';
        } else if (admin === true || customer === null) {
            label = 'common:status.ApprovedByCompany';
            color = 'green';
        }
        return <Badge color={color} content={t(label)} />;
    };

    return (
        <>
            <div className="container-selects">
                <Budget></Budget>
                <div className="div-datatable">
                    <div>
                        <h3>{t('spareparts:translation.OrderItems') + '(' + orderData?.orderItems?.length + ')'}</h3>
                        <Divider />
                        <Table>
                            <Table.Header>
                                <Table.HeaderCell content={t('common:translation.Item')} />
                                {orderData?.typeId != 4 ? (
                                    <Table.HeaderCell content={t('spareparts:translation.Deadline')} />
                                ) : (
                                    <Table.HeaderCell content={t('spareparts:productinfots.order_data.SerialNumberPart')} />
                                )}
                                {orderData?.typeId != 4 ? (
                                    <Table.HeaderCell content={t('spareparts:translation.DeadlinePersonlized')} />
                                ) : (
                                    <Table.HeaderCell content={t('spareparts:productinfots.order_data.SerialNumberEqp')} />
                                )}
                                <Table.HeaderCell content={t('spareparts:translation.HoneywellAprroval')} />
                                <Table.HeaderCell content={t('spareparts:translation.CustomerAprroval')} />
                                <Table.HeaderCell content={t('common:translation.Result')} />
                            </Table.Header>
                            <Table.Body>
                                {orderData?.orderItems?.map((item: OrderItemsDTO, index: number) => (
                                    <Table.Row key={index}>
                                        <Table.Cell width={3}>
                                            {item?.partNumber} {' / '}
                                            {item?.description}
                                        </Table.Cell>

                                        {orderData?.typeId != 4 ? (
                                            <Table.Cell width={3}>
                                                <Select
                                                    className="select-type"
                                                    disabled={
                                                        [UserRole.CLIENT, UserRole.CLIENTADMIN].includes(user?.role!) ||
                                                        orderData?.statusId === 3 ||
                                                        orderData?.statusId !== 2
                                                    }
                                                    options={deliveryTimeOptions}
                                                    placeholder={item?.deadline}
                                                    onChange={value => {
                                                        setOrderItems(old =>
                                                            [...old!].map(e => {
                                                                if (e.id == item.id) return { ...e, deadline: value };
                                                                else return e;
                                                            })
                                                        );
                                                    }}
                                                />
                                            </Table.Cell>
                                        ) : (
                                            <Table.Cell width={3}>{item?.serialNumberPart}</Table.Cell>
                                        )}

                                        <Table.Cell width={3}>
                                            {orderData?.typeId != 4 ? (
                                                <Input
                                                    disabled={
                                                        [UserRole.CLIENT, UserRole.CLIENTADMIN].includes(user?.role!) ||
                                                        orderData?.statusId === 3 ||
                                                        orderData?.statusId !== 2
                                                    }
                                                    onChange={value => {
                                                        setOrderItems(old =>
                                                            [...old!].map(e => {
                                                                if (e.id == item.id) return { ...e, deadline: value };
                                                                else return e;
                                                            })
                                                        );
                                                        setDisable(true);
                                                    }}
                                                    placeholder={item?.deadline}
                                                    // value={item?.deadline}
                                                />
                                            ) : (
                                                item?.serialNumberEquipment
                                            )}
                                        </Table.Cell>

                                        <Table.Cell width={3}>
                                            <Select
                                                className="select-type"
                                                options={listAproved}
                                                disabled={
                                                    [UserRole.CLIENT, UserRole.CLIENTADMIN].includes(user?.role!) ||
                                                    orderData?.statusId === 3 ||
                                                    orderData?.statusId !== 2
                                                }
                                                placeholder={
                                                    item?.adminApproval === true
                                                        ? t('common:status.Approved')
                                                        : item?.adminApproval === false
                                                        ? t('common:status.Rejected')
                                                        : t('common:status.WaitingCompany')
                                                }
                                                onChange={value => {
                                                    setOrderItems(old =>
                                                        [...old!].map(e => {
                                                            if (e.id == item.id && orderData.typeId === 4 && value)
                                                                return { ...e, adminApproval: value, customerApproval: true };
                                                            else if (e.id == item.id) return { ...e, adminApproval: value };
                                                            else return e;
                                                        })
                                                    );
                                                    setDisable(true);
                                                }}
                                            />
                                        </Table.Cell>

                                        <Table.Cell width={3}>
                                            <Select
                                                disabled={
                                                    [UserRole.ADMIN, UserRole.SUPERADMIN].includes(user?.role!) ||
                                                    item?.customerApproval ||
                                                    orderData?.statusId === 2
                                                }
                                                className="select-type"
                                                placeholder={
                                                    orderData?.typeId === 3 ||
                                                    orderData?.typeId === 4 ||
                                                    item.customerApproval === true
                                                        ? t('common:status.Approved')
                                                        : item?.customerApproval === false
                                                        ? t('common:status.Rejected')
                                                        : t('common:status.WaitingClient')
                                                }
                                                onChange={value => {
                                                    setOrderItems(old =>
                                                        old!.map(e =>
                                                            e.id === item.id
                                                                ? {
                                                                      ...e,
                                                                      customerApproval: value,
                                                                      reasonRejection: value === true ? '' : e.reasonRejection
                                                                  }
                                                                : e
                                                        )
                                                    );
                                                    setCustomerApprovals(prev => ({ ...prev, [item.id]: value }));

                                                    setDisable(true);
                                                }}
                                                options={listAproved}
                                            />

                                            {orderData?.typeId == 2 && customerApprovals[item.id] !== true && (
                                                <Table.Cell width={3} className="Select-Reason">
                                                    <Select
                                                        disabled={
                                                            [UserRole.ADMIN, UserRole.SUPERADMIN].includes(user?.role!) ||
                                                            orderData?.statusId !== 3 ||
                                                            customerApprovals[item.id] !== false
                                                        }
                                                        className="select-type"
                                                        placeholder={
                                                            item.reasonRejection
                                                                ? item.reasonRejection
                                                                : t('common:placeholders.Select.SelectReason')
                                                        }
                                                        options={reasonRejection}
                                                        onChange={value => {
                                                            setOrderItems(old =>
                                                                [...old!].map(e => {
                                                                    if (e.id == item.id) return { ...e, reasonRejection: value };
                                                                    else return e;
                                                                })
                                                            );
                                                            setDisable(true);

                                                            if (value === 'Outros motivos') {
                                                                setCustomReason(prev => ({ ...prev, [item.id]: true }));
                                                            } else {
                                                                setCustomReason(prev => {
                                                                    const newReasons = { ...prev };
                                                                    delete newReasons[item.id];
                                                                    return newReasons;
                                                                });
                                                            }
                                                        }}
                                                    />

                                                    {orderData?.statusId === 3 && customReason[item.id] && (
                                                        <Table.Cell className="OtherReasons">
                                                            <Input
                                                                disabled={!customReason[item.id]}
                                                                onChange={value => {
                                                                    setOrderItems(old =>
                                                                        [...old!].map(e => {
                                                                            if (e.id == item.id)
                                                                                return { ...e, reasonRejection: value };
                                                                            else return e;
                                                                        })
                                                                    );
                                                                    setDisable(true);
                                                                }}
                                                                placeholder={
                                                                    item.reasonRejection
                                                                        ? item.reasonRejection
                                                                        : t('spareparts:translation.TellReason')
                                                                }
                                                            />
                                                        </Table.Cell>
                                                    )}
                                                </Table.Cell>
                                            )}
                                        </Table.Cell>

                                        <Table.Cell>{showResultBadge(orderItems, item.id)}</Table.Cell>
                                    </Table.Row>
                                ))}
                            </Table.Body>
                        </Table>
                        <Card.Content className="buttonsSearch">
                            <Button
                                loading={loading}
                                type="primary"
                                disabled={!isButtonEnabled() || loading}
                                icon="slidercontrols-plus"
                                onClick={() => process()}
                                content={t('spareparts:productinfots.order_data.ProcessOrder')}
                                iconPosition="right"
                            />
                        </Card.Content>
                        <div>
                            {admin && warranty() && filteredHistory.length > 0 ? (
                                <div>
                                    <h3>Histórico</h3>
                                    <Divider />
                                    <Table>
                                        <Table.Header>
                                            <Table.HeaderCell content={t('common:translation.Item')} />
                                            <Table.HeaderCell
                                                content={t('spareparts:productinfots.order_data.SerialNumberPart')}
                                            />
                                            <Table.HeaderCell
                                                content={t('spareparts:productinfots.order_data.SerialNumberEqp')}
                                            />
                                            <Table.HeaderCell content={t('spareparts:translation.DateOrder')} />
                                            <Table.HeaderCell content={t('spareparts:translation.OrderId')} />
                                            <Table.HeaderCell content={t('common:translation.Partner')} />
                                        </Table.Header>
                                        <Table.Body>
                                            {filteredHistory.map((item: OrderHistoryDTO, index: number) => (
                                                <Table.Row key={index}>
                                                    <Table.Cell width={3}>
                                                        {item?.partNumber}
                                                        {' / '}
                                                        {item?.description}
                                                    </Table.Cell>
                                                    <Table.Cell width={3}>{item?.serialNumberPart}</Table.Cell>
                                                    <Table.Cell width={3}>{item?.serialNumberEquipment}</Table.Cell>
                                                    <Table.Cell width={3}>{formatDate(item?.orderDate)}</Table.Cell>
                                                    <Table.Cell width={3}>{item?.orderId}</Table.Cell>
                                                    <Table.Cell width={3}>{item?.orderCompanyName}</Table.Cell>
                                                </Table.Row>
                                            ))}
                                        </Table.Body>
                                    </Table>
                                </div>
                            ) : (
                                []
                            )}
                        </div>
                    </div>
                </div>
                <br></br>
            </div>
        </>
    );
};
export default Price;
